<template>
  <el-dialog
    class="dialog-smart-subscribe"
    title="智能订阅"
    :visible="isShowDialogSmartSubscribe"
    width="590px"
    :show-close="false"
  >
    <div class="content">
      <div class="row">
        <div class="label">订阅行业:</div>
        <div class="value">
          {{ smartSubscribe.industryName }}
          <span class="updateTodayCount"> （今日更新{{ smartSubscribe.updateTodayCount }}条） </span>
        </div>
      </div>
      <div class="row">
        <div class="label">订阅业务:</div>
        <div class="value">
          <el-checkbox
            :key="key"
            class="checkbox"
            v-for="(item, key) in smartSubscribe.businessCountData"
            v-model="item.checked"
          >
            {{ item.businessName }}
          </el-checkbox>
        </div>
      </div>
      <div class="row" style="margin-top: 10px">
        <div class="label">业务地区:</div>
        <div class="value">
          <BusinessAreaSelected />
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BusinessAreaSelected from "@/components/LayoutHeaderSearch/components/DialogSmartSubscribe/BusinessAreaSelected";
import { restAccountTenderSubscribeCreateOrUpdateSubscriber } from "@/services/common/subscribe";
import { deepClone, endTimestamp } from "@/utils/common";
import { getAreaJson } from "@/assets/areaJSON";
import { CookieKeys, Cookies } from "@/utils/cookieKey";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";

export default {
  name: "DialogSmartSubscribe",
  components: { BusinessAreaSelected },
  computed: {
    isShowDialogSmartSubscribe() {
      return this.$store.getters["industryZone/isShowDialogSmartSubscribe"];
    },
    smartSubscribe() {
      return this.$store.getters["industryZone/smartSubscribe"];
    },
    businessAreaSelected() {
      return this.$store.getters["industryZone/businessAreaSelected"];
    },
    industryZoneData() {
      return this.$store.getters["industryZone/industryZoneData"];
    },
    keywords() {
      return this.$store.getters["search/searchParams"].keywords;
    },
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
  },
  watch: {
    isShowDialogSmartSubscribe(val) {
      if (val) {
        this.$track(DEED_MAP.EXPOSURE, OID_MAP.SMART_SUBSCRIBE_EXPOSURE, {
          ctx: this.industryZoneData.id,
        });
      }
    },
  },
  methods: {
    async handleConfirm() {
      const businessAreaSelected = deepClone(this.businessAreaSelected);
      if (businessAreaSelected.length === 0) return this.$message.error("请选择业务地区");

      /** 1、areaIds **/
      let areaIds = "";
      if (businessAreaSelected.length === getAreaJson().length) {
        areaIds = "2703"; // 全国
      } else {
        for (let i = 0; i < businessAreaSelected.length; i++) {
          areaIds += `${businessAreaSelected[i].id},`;
        }
        // 去掉最后一个逗号
        areaIds = areaIds.slice(0, areaIds.length - 1);
      }

      /** 2、businessIds **/
      const businessCountData = deepClone(this.smartSubscribe.businessCountData);
      let checkedBusinesses = businessCountData.filter((v) => v.checked);

      /** 如果一个都没选，则默认帮助用户全部勾选 **/
      if (checkedBusinesses.length === 0) {
        const newBusinessCountData = businessCountData.reduce((prev, cur) => {
          cur.checked = true;
          prev.push(cur);
          return prev;
        }, []);
        this.$store.commit("industryZone/updateSmartSubscribe", {
          ...this.smartSubscribe,
          businessCountData: newBusinessCountData,
        });
        checkedBusinesses = newBusinessCountData;
      }

      let businessIds = "";
      for (let i = 0; i < checkedBusinesses.length; i++) {
        businessIds += `${checkedBusinesses[i].businessId},`;
      }
      // 去掉最后一个逗号
      businessIds = businessIds.slice(0, businessIds.length - 1);

      /** 3、industryId **/
      const industryId = this.industryZoneData.id;

      /** 4、subscribeName **/
      const subscribeName = this.keywords;

      /** 5、userId **/
      const userId = this.userInfo.userId;

      try {
        const res = await restAccountTenderSubscribeCreateOrUpdateSubscriber({
          areaIds,
          businessIds,
          industryId,
          infoTypeList: [0, 1, 2, 3, 4, 5], // 固定
          isSendEmail: 1, // 邮件推送 默认开启
          subscribeName,
          type: 3, // 招标订阅器类型 固定为3
          userId,
        });
        this.$store.commit("industryZone/updateSmartSubscribeId", res.data.id);
        this.$store.commit("industryZone/updateIsShowDialogSmartSubscribe", false);
        this.$store.commit("industryZone/updateIsShowDialogSmartSubscribeSuccess", true);
      } catch (e) {
        this.$store.commit("industryZone/updateIsShowDialogSmartSubscribe", false);
        this.$store.commit("industryZone/updateErrorMessage", e.msg);
        this.$store.commit("industryZone/updateIsShowDialogSmartSubscribeError", true);
      }
    },
    doNotDisturb() {
      let id_list = Cookies.get(CookieKeys.do_not_disturb_smart_subscribe_id_list);
      const industry_zone_id = this.industryZoneData.id;
      if (id_list) {
        // 存在
        id_list = JSON.parse(id_list);
        !id_list.includes(industry_zone_id) && id_list.push(industry_zone_id);
      } else {
        // 不存在
        id_list = [industry_zone_id];
      }
      Cookies.set(CookieKeys.do_not_disturb_smart_subscribe_id_list, JSON.stringify(id_list), {
        expires: new Date(endTimestamp()),
      });
    },
    handleCancel() {
      this.doNotDisturb();
      this.$store.commit("industryZone/updateIsShowDialogSmartSubscribe", false);
    },
  },
};
</script>

<style lang="scss">
@import "../../../../assets/config";

.dialog-smart-subscribe {
  .el-dialog__body {
    padding: 0 20px;
    color: $theme-font-color;
  }
  .el-checkbox {
    color: $theme-font-color;
  }
}
</style>

<style scoped lang="scss">
@import "../../../../assets/config";

.content {
  padding: 0 24px;

  .row {
    margin-top: 20px;
    display: flex;

    .label {
      flex-shrink: 0;
      color: #595959;
    }

    .value {
      margin-left: 15px;

      .updateTodayCount {
        color: $theme-color;
      }

      .checkbox {
        margin-right: 25px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
